import { captureException } from '@sentry/react';
import { StateCreator } from 'zustand';

import { unauthorizedAxiosInstance } from '@/clients';

import { AuthActions, AuthState } from '../types';

export const createAuthActions: StateCreator<AuthState & AuthActions, [['zustand/immer', never]], [], AuthActions> = (
    set,
    get,
    store,
) => ({
    // Core
    setAccessToken: async (token: string | null) => {
        set({ accessToken: token });
    },
    setRefreshing: async (val: boolean) => {
        set({ isRefreshing: val });
    },
    setReferralContext: async (context) => {
        set((state) => {
            state.referralContext = {
                ...state.referralContext,
                ...context,
            };
        });
    },
    resolveReferralContext: async ({ dubClickId, referralCode }) => {
        const normalizedReferralCode = referralCode.trim();

        if (!normalizedReferralCode) {
            set((state) => {
                state.referralContext = {
                    referralCode: '',
                    dubClickId: '',
                    resolution: null,
                    resolving: false,
                };
            });

            return;
        }

        set((state) => {
            state.referralContext = {
                ...state.referralContext,
                referralCode: normalizedReferralCode,
                dubClickId,
                resolving: true,
                error: undefined,
            };
        });

        try {
            const res = await unauthorizedAxiosInstance.post('/auth/referrals/resolve', {
                referralCode: normalizedReferralCode,
            });

            if (get().referralContext.referralCode !== normalizedReferralCode) return;

            set((state) => {
                state.referralContext = {
                    ...state.referralContext,
                    referralCode: normalizedReferralCode,
                    dubClickId,
                    resolution: res.data,
                    resolving: false,
                };
            });
        } catch (error) {
            captureException(error);

            if (get().referralContext.referralCode !== normalizedReferralCode) return;

            set((state) => {
                state.referralContext = {
                    ...state.referralContext,
                    referralCode: normalizedReferralCode,
                    dubClickId,
                    resolution: null,
                    resolving: false,
                    error: 'Failed to resolve referral invitation',
                };
            });
        }
    },
    clearReferralContext: async () => {
        set((state) => {
            state.referralContext = {
                referralCode: '',
                dubClickId: '',
                resolution: null,
                resolving: false,
            };
        });
    },
    logout: async () => {
        set({ accessToken: null });

        window.location.href = '/login';
    },
});
